import { Component, Vue, Prop } from 'vue-property-decorator';
import { Icon } from '../../components';

@Component
export default class Alert extends Vue {
  @Prop() label!: string;
  @Prop() icon!: string;
  @Prop() name!: string;
  @Prop() labelClass!: string;
  @Prop() iconClass!: string;
  @Prop() labelStyle!: {};
  @Prop() iconStyle!: {};

  render(): JSX.Element {
    return (
      this._renderInlineAlert(this._getIconClass())
    );
  }

  private _getIconClass(): string {
    let className: string = '';
    if (this.name === 'icon-system-alert-small') { // error
      className = 'alert-inline-warning';
    } else if (this.name === 'icon-system-tick-copy') { // info
      className = 'icon-color-Active';
    } else if (this.name === 'icon-system-info-small') { // help
      className = 'icon-color-Disabled';
    } else if (this.name === 'alert-inline-success') { // success
      className = 'icon-system-success';
    }
    return 'tl-svg-info-icon ' + className + ' ' + this.iconClass;
  }

  private _renderInlineAlert(type: string): JSX.Element {
    const alertClass: string = this.labelClass ? 'alert-label ' + this.labelClass : 'alert-label body14-light';
    return (
      <div class={'tl-inline-alert-container '}>
        {this.icon ? <svg class={type} style={this.iconStyle}><Icon name={this.icon} /></svg> : ''}
        <span class={alertClass} style={this.labelStyle}>{this.label}</span>
      </div>
    );
  }


}
